import RoutingActions from '../../../actions/RoutingActions';
import PosCartActions from '../../../actions/PosCartActions';
import PosActions from '../../../actions/PosActions';

import PosStore from '../../../stores/PosStore';
import PosCartStore from '../../../stores/PosCartStore';

class AppliedDiscounts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            appliedDiscounts : PosCartStore.getState().appliedDiscounts
        };

        this.componentWillMount = this.componentWillMount.bind(this);
        this.onPosCartStoreChange = this.onPosCartStoreChange.bind(this);
    }

    componentWillMount() {
        PosActions.loadAppliedDiscounts(this.props.guest.ShipmentId)

        PosCartStore.addChangeListener(this.onPosCartStoreChange);
    }

    componentWillUnmount() {
        PosCartStore.removeChangeListener(this.onPosCartStoreChange);
    }

    onPosCartStoreChange() {
        this.setState({
            appliedDiscounts : PosCartStore.getState().appliedDiscounts
        });
    }

    render() {
        var guest            = this.props.guest;
        var appliedDiscounts = this.state.appliedDiscounts;
        var amount           = 0;
        var rowStyle         = '#dddddd';
        const selectedItem = this.props.selectedItem;

        return (
            <div className='applied-discounts'>

                <div className='applied-discounts__header'>
                    DISCOUNTS ALREADY APPLIED
                </div>

                <div className='applied-discounts__container'>
                    { appliedDiscounts
                        .filter(discount => discount.InvId === selectedItem.InventoryId)
                        .map((discount, i) =>
                        {
                            rowStyle = rowStyle === '#dddddd' ? '#ebebeb' : '#dddddd';
                            return (
                                <div
                                    className='applied-discounts__discount'
                                    style={{'backgroundColor' : rowStyle }}
                                    key={'discount_'+discount.InvId}>

                                    <div className='applied-discounts__discount--title'>
                                        {discount.DiscountReason}
                                    </div>

                                    {!discount.IsLoyalty &&
                                    <div
                                        className='applied-discounts__discount--remove'
                                        onClick={() => { PosCartActions.removeAppliedDiscount(guest, discount.AppliedDiscountId, true); }}>

                                        <i className='fa fa-times' aria-hidden='true' />
                                    </div>}

                                </div>
                            );
                        }
                    )}
                </div>

            </div>
        );
    }
}

export default AppliedDiscounts;

/*

                    { discounts.map((discount) => {

                        rowStyle = rowStyle === '#ffffff' ? '#ebebeb' : '#ffffff';
                        amount = discount.FlatFee !== 0 ? '$'+discount.FlatFee.toString() : (discount.PercentOff * 100).toString()+'%';

                        return (
                            <div
                                style={{'backgroundColor' : rowStyle }}
                                key={discount.ProductId}>

                                <div className='available-discounts__row'>
                                    <div className='available-discounts__row--name'>
                                        {discount.ProductDesc}
                                    </div>
                                    <div className='available-discounts__row--amount'>
                                        {amount}
                                    </div>
                                    <div className='available-discounts__row--exp'>
                                        {moment(discount.ValidateDt).format('MMM D, YYYY')}
                                    </div>
                                </div>

                            </div>
                        );

                    })}

*/



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/discount/AppliedDiscounts.react.jsx